import React from "react";
import { FaTimes } from "react-icons/fa";
import "./videos-popup.scss";

const VideosPopUp = (props) => {
  const compClass = "o-videosPopUp";
  const { showPopUp, actualVideo, setShowPopUp } = props;
  if (!showPopUp) return <></>;
  return (
    <div className={compClass}>
      <div className={`${compClass}__iframeWrapper`}>
        <iframe
          src={actualVideo?.video || actualVideo?.redireccionBoton}
          title={"Multimedia"}
          frameborder={0}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <FaTimes
          onClick={() => setShowPopUp(false)}
          className={`${compClass}__icon`}
        />
      </div>
    </div>
  );
};

export default VideosPopUp;
